import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const CircularCreateLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'CircularCreate' */ './components/CreateCircular'
		)
);

export default (store) => {
	return {
		path: 'home/circular-dashboard/:view/create-circular',
		element: (
			<AsyncLoading
				component={
					<CircularCreateLazy
						permission="CanCreateAnnouncements"
						featureFlag="Module:Announcement"
					/>
				}
			/>
		),
	};
};
